import { render, staticRenderFns } from "./TooltipRincianOrder.vue?vue&type=template&id=19c3d307&"
import script from "./TooltipRincianOrder.vue?vue&type=script&lang=js&"
export * from "./TooltipRincianOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports